<template>
    <layout>
    	<!-- Image header -->
    	<div class="bg-image img-rounded overflow-hidden push bg-trees">
    		<div class="bg-black-op">
    			<div class="content">
    				<div class="block block-transparent block-themed text-center">
    					<div class="block-content">
    						<h1 class="h1 font-w700 text-white animated fadeInDown push-5">Dashboard</h1>
    						<h2 class="h4 font-w400 text-white-op animated fadeInUp">Welcome {{ user.contact.first_name }} {{ user.contact.last_name }}</h2>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    	<!-- END image header -->

    	<!-- Stats -->
    	<div v-show="isLeadingAdmin" class="row text-uppercase">
            <div class="col-xs-12 col-sm-3 pull-right">
    			<div class="block block-rounded">
    				<div class="block-content block-content-full">
    					<div class="font-w700 font-s13 text-gray-darker animated fadeIn">Placeholder</div>
                        <div class="text-muted animated fadeIn">
                            <small><i class="icon-calendar"></i> TODAY</small>
                        </div>
                        <div class="animated flipInX">
    					   <a class="h2 font-w300 text-primary">100</a>
                        </div>
    				</div>
    			</div>
    		</div>
    		<div class="col-xs-12 col-sm-3 pull-right">
    			<div class="block block-rounded">
    				<div class="block-content block-content-full">
    					<div class="font-w700 font-s13 text-gray-darker animated fadeIn">Awaiting Approval | <a class="text-primary" @click="goFilteredInspections('submitted')"> MORE</a> </div>

                        <div class="text-muted animated fadeIn">
                            <small><i class="icon-heart"></i> TODAY</small>
                        </div>
                        <div class="animated flipInX">
    					   <a class="h2 font-w300 text-primary" @click="goFilteredInspections('submitted')">{{ stats.total_submitted }}</a>
                        </div>
    				</div>
    			</div>
    		</div>
    		<div class="col-xs-12 col-sm-3 pull-right">
    			<div class="block block-rounded">
    				<div class="block-content block-content-full">
    					<div class="font-w700 font-s13 text-gray-darker animated fadeIn">Post Modified | <a class="text-primary" @click="goFilteredInspections('modified')"> MORE</a> </div>
                        <div class="text-muted animated fadeIn">
                            <small><i class="icon-calendar"></i> TODAY</small>
                        </div>
                        <div class="animated flipInX">
    					   <a class="h2 font-w300 text-primary" @click="goFilteredInspections('modified')">{{ stats.total_modified }}</a>
                        </div>
    				</div>
    			</div>
    		</div>
    		<div class="col-xs-12 col-sm-3 pull-right">
    			<div class="block block-rounded">
    				<div class="block-content block-content-full">
    					<div class="font-w700 font-s13 text-gray-darker animated fadeIn">Not Yet Submitted | <a class="text-primary" @click="goFilteredInspections('not_submitted')"> MORE</a> </div>
                        <div class="text-muted animated fadeIn">
                            <small><i class="icon-calendar"></i> TODAY</small>
                        </div>
                        <div class="animated flipInX">
    					   <a class="h2 font-w300 text-primary" @click="goFilteredInspections('not_submitted')">{{ stats.total_not_submitted }}</a>
                        </div>
    				</div>
    			</div>
    		</div>
    	</div>
        <div v-show="isLeadingInspector" class="row text-uppercase">
    		<div class="col-xs-6 col-sm-3 pull-right">
    			<div class="block block-rounded">
    				<div class="block-content block-content-full">
    					<div class="font-w700 font-s13 text-gray-darker animated fadeIn">Rejected Submissions | <a class="text-primary" @click="goFilteredInspections('rejected')"> MORE</a></div>
                        <div class="text-muted animated fadeIn">
                            <small><i class="icon-calendar"></i> TODAY</small>
                        </div>
                        <div class="animated flipInX">
    					   <a class="h2 font-w300 text-primary" @click="goFilteredInspections('rejected')">{{ stats.total_rejected }}</a>
                        </div>
    				</div>
    			</div>
    		</div>
    		<div class="col-xs-6 col-sm-3 pull-right">
    			<div class="block block-rounded">
    				<div class="block-content block-content-full">
    					<div class="font-w700 font-s13 text-gray-darker animated fadeIn">Incomplete Inspections | <a class="text-primary" @click="goFilteredInspections('not_submitted')"> MORE</a></div>
                        <div class="text-muted animated fadeIn">
                            <small><i class="icon-calendar"></i> TODAY</small>
                        </div>
                        <div class="animated flipInX">
    					   <a class="h2 font-w300 text-primary" @click="goFilteredInspections('not_submitted')">{{ stats.total_not_submitted }}</a>
                        </div>
    				</div>
    			</div>
    		</div>
    	</div>
    	<!-- END stats -->

        <div class="row">
            <div class="col-xs-12">
                <div class="block block-rounded block-opt-refresh-icon8">
                    <div class="block-content block-content-full" style="min-height: 300px;">
                        <div class="inspection-table">
                            <inspection-list ref="recentList" :count="recentLength" :inspections="inspections" :columns="inspectionListColumns"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Export button -->
        <div class="block block-rounded">

            <div class="block-content">
                <div class="row">
                    <div class="col-xs-3">
                        <div class="font-w700 font-s15 text-gray-darker">Export Inspections</div>
                    </div>
                    <div class="col-xs-3">
                        <wc-date label="From" v-model="exportStartDate" :neverDirty="true"></wc-date>
                    </div>
                    <div class="col-xs-3">
                        <wc-date label="To" v-model="exportEndDate" :neverDirty="true"></wc-date>
                    </div>
                    <div class="col-xs-3">
                        <button type="button" style="margin-top:25px;" class="btn btn-block btn-primary pull-right" @click="exportInspections">
                            <i class="fa fa-file"></i> CSV
                        </button>
                    </div>
                </div>
            </div>

        </div>
        <!-- End export button -->

    </layout>
</template>

<script>
    import roleMixin from '../../mixins/role-mixins.js';



    Date.prototype.formatMMDDYYYY = function(){
        return (this.getMonth() + 1) +
        "/" +  this.getDate() +
        "/" +  this.getFullYear();
    }

    const today = new Date();
    const twoWeeksAgo = new Date();   twoWeeksAgo.setDate(today.getDate() - 7);



    export default {
        mixins: [ roleMixin ],
        name: 'home',
        components: {
            layout: require('../layouts/default.vue'),
            inspectionList: require('../elements/inspection-list.vue'),
            wcDate: require('../elements/forms/wc-date.vue'),
        },
        data () {
            return {
                stats: [],
                inspections: [],
                chart: null,
                recentLength: 10,
                user: this.$schema.map('user'),
                exportStartDate: twoWeeksAgo.formatMMDDYYYY(),
                exportEndDate: today.formatMMDDYYYY()
            };
        },
        computed: {
            inspectionListColumns() {
                return this.isAdmin ? ['inspector'] : [];
            },
        },
        methods: {

            exportInspections() {
                let saveByteArray = (function() {

                    return function(data, name) {
                        let blob = new Blob(data, { type: "octet/stream" });

                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob, name);
                        } else {
                            let a = document.createElement("a");
                            document.body.appendChild(a);
                            a.setAttribute("style", "display: none");

                            let url = URL.createObjectURL(blob);
                            a.href = url;
                            a.download = name;
                            a.click();
                            window.URL.revokeObjectURL(url);
                        }
                    };
                })();


                this.axios.get(`inspections/csv?from=${(new Date(this.exportStartDate)).getTime()/1000}&to=${(new Date(this.exportEndDate)).getTime()/1000}`).then((response) => {
                    saveByteArray([response.data], `${this.exportStartDate} to ${this.exportEndDate}.csv`);
                });
            },

            goFilteredInspections (by) {
                this.$router.push({ name: 'inspections-filtered', params: { status_filter: by }})
            }

        },
        created () {
            var self = this;

            self.axios.get('users/me').then((response) => {
                this.user = response.data;
            });

            self.axios.get('stats').then((response) => {
                self.stats = response.data;
            });

            self.axios.get('inspections?include=region,status,contact,inspector&count=' + self.recentLength).then((response) => {
                self.inspections = response.data.data;
            });
        },
        mounted () {}
    };
</script>

<style scoped>
	.bg-forest-fog {
		background-image: url('../../assets/img/trees.jpg');
	}
</style>



// WEBPACK FOOTER //
// home.vue?089f8da6